import { User, UserTypes } from "models/User/User.types";

type CommunicationPreferenceUser = Partial<Pick<User, "type" | "user_type" | "userType">> | null | undefined;

export const COMMUNICATION_PREFERENCE_FIELDS = ["communications", "opt_in_sms", "opt_in_email"] as const;

export const canManageCommunicationPreferences = (currentUser: CommunicationPreferenceUser): boolean => {
  return (
    currentUser?.userType === UserTypes.TenantAdmin ||
    currentUser?.userType === UserTypes.Practitioner ||
    currentUser?.user_type === UserTypes.TenantAdmin ||
    currentUser?.user_type === UserTypes.Practitioner ||
    currentUser?.type === UserTypes.TenantAdmin ||
    currentUser?.type === UserTypes.Practitioner
  );
};

export const restrictCommunicationPreferencePayload = <T extends object>(
  payload: T,
  currentUser: CommunicationPreferenceUser
): T => {
  if (canManageCommunicationPreferences(currentUser)) return payload;

  const permittedPayload = { ...payload } as Record<string, unknown>;
  COMMUNICATION_PREFERENCE_FIELDS.forEach((field) => {
    delete permittedPayload[field];
  });

  return permittedPayload as T;
};
